import React, { useEffect, useState } from 'react';
import { BreadcrumpComponent } from '../components/subcomponents/BreadcrumpCompont';
import { PageSectionHeader } from '../components/subcomponents/PageSectionHeader';
import { Colors } from '../utils/utils.colors';
import { LuChevronRight } from 'react-icons/lu';
import heroImage from '../assets/images/hero-image.png';
import { FAQItem } from '../components/subcomponents/Faqitem';
import { apiGet } from '../utils/api';
import { useLanguage } from '../contexts/LanguageContext';
import { pickLocalized } from '../utils/locale';

const LuChevronRightIcon = LuChevronRight as any;

export const Faq: React.FC = () => {
    const { lang } = useLanguage();
    const [items, setItems] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiGet('/faqs')
            .then((res) => setItems(res.rows || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

  const subtitle = lang === 'en'
    ? 'Find answers to the most frequently asked questions about ULPGL, our services and our commitment to sustainability.'
    : "Retrouvez ici les réponses aux questions les plus fréquemment posées sur l'ULPGL, nos services et notre engagement envers la durabilité.";

  const hint = lang === 'en'
    ? "Can't find your answer? Contact our guidance office via the Contact page."
    : "Vous ne trouvez pas votre réponse ? N'hésitez pas à contacter notre service d'orientation via la page Contacts.";

    return (
        <>
            <BreadcrumpComponent
                imageCover={heroImage}
                subtitle={subtitle}
                title={<span style={{ color: Colors.whiteColor }}>FAQ <LuChevronRightIcon size={14} /> {lang === 'en' ? 'Frequently asked questions' : 'Foire aux questions'} </span>}
            />
            <div className="page-content is-layout-container">
                <div className="padding-x is-layout-constrained">
                    <PageSectionHeader
                        eyebrow="Aide"
                        title={lang === 'en' ? 'Frequently asked questions' : 'Foire aux questions'}
                        lead={hint}
                        align="start"
                    />

                    <div className="wp-block-query is-layout-flow wp-block-query-is-layout-flow">
                        {loading && <p style={{ color: '#888' }}>{lang === 'en' ? 'Loading…' : 'Chargement…'}</p>}
                        {!loading && items.length === 0 && <p style={{ color: '#888' }}>{lang === 'en' ? 'No questions available.' : 'Aucune question disponible.'}</p>}
                        {items.map((faq, index) => (
                            <FAQItem
                                key={faq.id}
                                number={`${String(index + 1).padStart(2, '0')}.`}
                                question={pickLocalized(faq, 'question', lang)}
                                answer={pickLocalized(faq, 'answer', lang)}
                                slug={faq.slug}
                            />
                        ))}
                    </div>

                    <div style={{ height: '81px' }} aria-hidden="true" className="wp-block-spacer"></div>
                </div>
            </div>
        </>
    )
}
